import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-template',
  templateUrl: './card-template.component.html',
  styleUrls: ['./card-template.component.css']
})
export class CardTemplateComponent implements OnInit {
  @Input() navlinks;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/card-template/card-template.component.ts